import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Bot from './Bot';
import User from './User';
import { observer } from "mobx-react";
import store from '../store/main';
import _ from 'lodash';

class Chat extends Component {

    scrollToBottom = () => {
        const messagesContainer = ReactDOM.findDOMNode(this.messagesContainer);
        messagesContainer.scrollTop = messagesContainer.scrollHeight;
    };

    componentDidUpdate(nextProps) {
        this.scrollToBottom();
    }

    render() {
        //  console.log(store.messages);
        const messages = store.messages.map((message) => {
            if(message.owner === 'bot') 
            return <Bot key={_.uniqueId()} message={message.text} options={message.options} buttons = {message.buttons} time={message.time} loading={message.loading}/>
            return <User key={_.uniqueId()} message={message.text} time={message.time} />
        })

        return (
            <blockquote ref={(el) => { this.messagesContainer = el }}>
                { messages }
            </blockquote>
        )
    }
}

export default observer(Chat);
